"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
import { usePopupState } from "../hooks/usePopupState";
interface VerifiedBadgeProps {
  businessName: string;
  className?: string;
}

/**
 * Displays a verified badge with an information popup explaining what "verified" means.
 * Includes a link to Trustpilot's trust page for more information.
 */
export const VerifiedBadge = t0 => {
  const $ = _c(21);
  const {
    businessName,
    className
  } = t0;
  const {
    showPopup,
    setShowPopup,
    containerRef,
    handleMouseEnter,
    handleMouseLeave
  } = usePopupState();
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative inline-flex items-center gap-1 text-sm text-gray-600", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg aria-hidden="true" className="h-4 w-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== setShowPopup || $[4] !== showPopup) {
    t3 = () => setShowPopup(!showPopup);
    $[3] = setShowPopup;
    $[4] = showPopup;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== businessName) {
    t4 = <span>Verified, collected by {businessName}</span>;
    $[6] = businessName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== showPopup || $[9] !== t3 || $[10] !== t4) {
    t5 = <button type="button" className="cursor-pointer text-left hover:underline focus:underline focus:outline-none" onClick={t3} aria-expanded={showPopup} aria-haspopup="dialog">{t4}</button>;
    $[8] = showPopup;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== showPopup) {
    t6 = showPopup && <div className="absolute top-full left-0 z-50 mt-2 w-80 rounded-lg border border-gray-200 bg-white p-4 shadow-lg" role="dialog" aria-modal="false"><p className="text-sm text-gray-700">Product reviews are labeled <strong>verified</strong> when a company invites people to leave a review, using our supported invitation methods.{" "}<a href="https://corporate.trustpilot.com/trust?utm_medium=Trustbox&utm_source=ProductListImportedSEO" target="_blank" rel="noopener noreferrer" className="font-medium text-blue-600 underline hover:text-blue-800">Learn more</a></p></div>;
    $[12] = showPopup;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== containerRef || $[15] !== handleMouseEnter || $[16] !== handleMouseLeave || $[17] !== t1 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div ref={containerRef} className={t1} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>{t2}{t5}{t6}</div>;
    $[14] = containerRef;
    $[15] = handleMouseEnter;
    $[16] = handleMouseLeave;
    $[17] = t1;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};